import {useEffect, useState} from 'react';

import {useStores} from '../stores/use-stores';

export default function useIsLoggedIn() {
  const {userStore} = useStores();
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    setIsLoggedIn(userStore.isLoggedIn());
  }, [userStore, userStore.sessionToken]);

  return isLoggedIn;
}
